import { Component, OnInit, Optional } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { CoreLibService, Group, Query } from 'core-lib';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'lib-group-picker',
    templateUrl: './group-picker.component.html',
    styleUrls: ['./group-picker.component.scss'],
    standalone: false
})
export class GroupPickerComponent implements OnInit {

  groups: Group[] = [];
  selectedGroup: Group;

  QUERY_GROUPS = gql`
  query listMyGroups{
    listGroups{
      id
      name
      numberOfMembers
      memberIds
    }
    whoami {
      userProfile{
        groups{
          id
          name
          numberOfMembers
          memberIds
        }
      } 
    }  
  }`;

    

  constructor(private apollo: Apollo, private messageService: MessageService, @Optional() private dialogRef: DynamicDialogRef, private coreLibService: CoreLibService) {

  }

  /**
  * init
  */
  ngOnInit(): void {
  
    this.apollo.query<Query>({
      query: this.QUERY_GROUPS,
      variables: {}
    }).subscribe((result) => {
      if (this.coreLibService.hasAnyClaims(['group_read'])){
        this.groups = result.data.listGroups;
      }else{
        this.groups = result.data.whoami.userProfile?.groups;
      }
    });
  }

  /**
   * group selected
   */
  onAcceptGroup(): void {
    this.dialogRef.close(this.selectedGroup );
  }
}
